import { render } from "./RedirectNothing.vue?vue&type=template&id=126796dd&scoped=true"
import script from "./RedirectNothing.vue?vue&type=script&lang=js"
export * from "./RedirectNothing.vue?vue&type=script&lang=js"

import "./RedirectNothing.vue?vue&type=style&index=0&id=126796dd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126796dd"]])

export default __exports__